module.exports = __webpack_public_path__ + "img/qa.ac3b42c7.png";